import React from 'react'

function About() {
    return (
        <div name="about" className='w-full h-screen bg-gradient-to-b from-gray-800 to-black text-white '>
            <div className='max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full'>

                
                    <div className= "pb-8">
                        <p className='text-4xl font-bold inline border-b-4 border-gray-500'>About</p>
                        

                        </div>
                        <p className='text-xl mt-20'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Facere saepe, iure aliquam quae cupiditate esse? Officia aut deserunt repellat beatae amet dolorem veniam inventore natus, cumque temporibus voluptatum fugiat expedita facere. Voluptas aut labore enim in quas ea amet soluta! Ex optio minima officiis reprehenderit vero voluptate nobis, sapiente obcaecati.</p>
                        <br />
                        <p className='text-xl'>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Ipsa in quod nostrum magnam animi explicabo ad reprehenderit, neque delectus nisi atque ipsum minima rem cupiditate voluptate nemo veritatis possimus earum. Provident illum amet qui veritatis accusantium ut! Molestias cum labore nihil quos explicabo. Rem quidem omnis veniam odit, repellat nihil?</p>
                   
            </div>
        </div>
            )
}

            export default About